import styled from 'styled-components'

const StyledDesignerStickersPanel = styled.div``

export default StyledDesignerStickersPanel
